module.exports = __webpack_public_path__ + "static/media/6-focus.fd068808.svg";